import { useRef } from "react";

export const useExecutePreMount = callback => {
  const first = useRef(true);

  if (first.current) {
    callback();
    first.current = false;
  }
};